// extracted by mini-css-extract-plugin
export default {"promo-bg":"style_promo-bg__Ls7hU","promo-content-wrapper":"style_promo-content-wrapper__l6QfT"};